<template>
  <div class="freightPriceCalculator">
    <van-form @submit="onSubmit(0)" label-width="80px">
      <van-field
        :label="$t.calculator.length"
        :placeholder="$t.calculator.input"
        v-model="form.Length"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        :label="$t.calculator.width"
        :placeholder="$t.calculator.input"
        v-model="form.Width"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        :label="$t.calculator.height"
        :placeholder="$t.calculator.input"
        v-model="form.Height"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        :label="$t.calculator.weight"
        :placeholder="$t.calculator.input"
        v-model="form.WeightKG"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        readonly
        clickable
        :value="fpid.text"
        :label="$t.calculator.col1"
        :placeholder="$t.calculator.select"
        @click="onShowFpid"
        required
        :rules="[
          {
            required: true,
            message: $t.calculator.select + ' ' + $t.calculator.col1,
          },
        ]"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.calculator.search
        }}</van-button>
      </div>
    </van-form>

    <div class="search-top" v-if="tableList.length > 0">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="tabItem" @click="onSubmit(0)">
          <p :class="['tabItemTotal', form.OrderBy == 0 ? 'itemTopAction' : '']">
            {{ $t.calculator.orderBy1 }}
          </p>
        </van-col>
        <van-col class="tabItem" @click="onSubmit(1)">
          <p :class="['tabItemTotal', form.OrderBy == 1 ? 'itemTopAction' : '']">
            {{ $t.calculator.orderBy2 }}
          </p>
        </van-col>
      </van-row>
    </div>

    <div class="table-content">
      <calculator-table
        :tableList="tableList"
        :isCustomer="isCustomer"
      ></calculator-table>
    </div>

    <option-list
      event="showCalculatorFreightPrice"
      :options="fpidList"
      @onSelect="onSelectFpid"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Row, Col, Button, Image } from "vant";
import calculatorTable from "./components/calculator-table";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Row).use(Col).use(Button).use(Image);
export default {
  name: "freightPriceCalculator",
  components: {
    calculatorTable,
    OptionList,
  },
  data() {
    return {
      isCustomer: false,
      form: {
        Length: null,
        Width: null,
        Height: null,
        WeightKG: null,
        OrderBy: 0,
      },
      fpid: { text: "", value: "" },
      fpidList: [],
      tableList: [],
    };
  },
  created() {
    const { IsCustomer } = this.$route.query;
    this.isCustomer = IsCustomer ? true : false;
    this.getFreightPriceListByPage();
  },
  methods: {
    onSelectFpid(item) {
      this.fpid.text = item.text;
      this.fpid.value = item.value;
    },
    onShowFpid() {
      this.$bus.$emit("showCalculatorFreightPrice", true);
    },
    getFreightPriceListByPage() {
      this.$commonMethod.showLoading();
      var param = {};
      return new Promise((resolve) => {
        this.$api.onlineOrderManagement
          .getFreightPriceListByPage(param)
          .then((res) => {
            this.formatFreightPrice(res.data.Data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatFreightPrice(items) {
      items.forEach((item) => {
        let data = {
          text: item.CountryName,
          image: item.NationalFlagPicture,
          value: item.FPId,
        };
        this.fpidList.push(data);
      });
    },
    onSubmit(orderBy) {
      var param = this.form;
      param.OrderBy = orderBy;
      param.FPId = this.fpid.value;
      this.$commonMethod.showLoading();
      this.$api.calculator
        .freightPriceCalculator(param)
        .then((res) => {
          this.tableList = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.freightPriceCalculator {
  .search-top {
    margin-top: 5vw;
    color: #333;
    text-align: center;
    .search-top-row {
      width: 100%;
      text-align: center;
      padding-top: 15px;
      padding-bottom: 15px;
      border-top: 1px solid #ebedf0;
      border-bottom: 1px solid #ebedf0;
      .tabItem {
        width: 50%;
        text-align: center;
        font-size: 14px;
        color: #a7a7a7;
        .tabItemTotal {
          margin: 0;
          padding: 0;
        }
        .itemTop {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          -webkit-align-items: center;
          list-style: none;
          text-align: center;
          justify-content: center;
          -webkit-justify-content: center;
          .itemTopName {
            margin: 0;
            padding: 0;
          }
        }
        .itemTopAction {
          color: #028ef3;
          font-weight: bold;
        }
      }
    }
  }
  .table-content {
    margin-top: 10px;
    height: auto;
  }
}
</style>
